<template>
  <div>
    <GameTemplate :game="game" :platform="platform" @add-score="addScore"
                  @go-to-platform="goToPlatform"></GameTemplate>
  </div>
</template>

<script>
  import axios from 'axios';
  import GameTemplate from '@/components/templates/GameTemplate.vue';
  import api from '../api';

  export default {
    components: { GameTemplate },
    data: () => ({
      game: {
        difficulties: [],
        modes: [],
        rankings: [],
      },
    }),
    computed: {
      gameId() {
        return this.$route.params.id;
      },
      platform() {
        return this.$route.params.platform;
      },
    },
    mounted() {
      axios
        .get(`${api.endpoint}/games/${this.gameId}`)
        .then(response => response.data)
        .then(game =>
          axios.get(`${api.endpoint}/games/${this.gameId}/rankings`).then(response => {
            game.rankings = response.data;
            this.game = game;
          }),
        );
    },
    methods: {
      addScore() {
        window.location.href = `http://hiscores.shmup.com/game/${this.gameId}/new_score`;
      },
      goToPlatform(platform) {
        this.$router.push({ name: 'platform', params: { platform } });
      },
    },
  };
</script>
